import * as React from 'react'
import { useState, useEffect } from 'react'
import { usePullShipmentsMutation, usePullStatusQuery } from '../../hooks/queries/shipments'

type PullShipmentsButtonProps = {
  jobnumberId: number
  setShipments: (shipments: any) => void
}

export default function PullShipmentsButton(props: PullShipmentsButtonProps) {
  const { jobnumberId, setShipments } = props
  const [isPolling, setIsPolling] = useState(false)

  const pullShipmentsMutation = usePullShipmentsMutation()
  const statusQuery = usePullStatusQuery(jobnumberId, isPolling)

  useEffect(() => {
    if (isPolling && statusQuery.data) {
      if (statusQuery.data.status === 'idle') {
        setIsPolling(false)
        if (statusQuery.data.shipments) {
          setShipments(statusQuery.data.shipments)
        }
      }
    }
  }, [isPolling, statusQuery.data, setShipments])

  const loadShipments = () => {
    pullShipmentsMutation.mutate(jobnumberId, {
      onSuccess: data => {
        setShipments(data.shipments)
        if (data.status === 'in_progress') {
          setIsPolling(true)
        }
      },
    })
  }

  const isLoading = pullShipmentsMutation.isLoading || isPolling

  return (
    <button className="btn btn-outline-primary btn-sm" type="button" disabled={!jobnumberId || isLoading} onClick={loadShipments}>
      {isLoading ? (
        <>
          <i className="fa fa-spinner fa-spin" />
        </>
      ) : (
        <>
          <i className="fa fa-download mr-2" /> Hent
        </>
      )}
    </button>
  )
}
